import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MapContext } from '../MapView/MapView';

//Start Css code ...
const useStyles = makeStyles({
  root: {
    width: 500,
  },
  mapBlock: {
    '& div': {
      padding: '10px',
      '& p': {
        marginBottom: '5px',
        marginTop: '5px',
      }
    },
    '& img': {
      width: '100%',     
      cursor: 'pointer',
      border: '1px solid #24618E',
      '@media only screen and (max-width: 3500px)': {
        height: '190px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '350px',
      },    
    }
  },
  mapGal: {
    overflowY: 'scroll',
    '@media only screen and (max-width: 3500px)': {
      height: '450px',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '730px',
    },      
  },
  mapGalInner: {
    height: '775px',
    padding: '10px'
  },
  mainbtnDiv: {
    border: '1px solid #24618E',
    borderTop: 'none',
    borderRadius: '0px 0px 5px 5px',    
    '& .focusBtn': {
      color: "#fff",
      background: '#24618E',
    },
    '@media only screen and (max-width: 3500px)': {
      minHeight: '365px',
    },
    '@media only screen and (min-width: 3501px)': {
      minHeight: '665px',
    },
  },
  thumbnailLeft : {
    width: '46%',
    float:'left'
  },
  thumbnailRight:{
    width:'46%',
    float:'right'
  }

});
//End Css code ...


//Start Basemaps component code ...
const Basemaps = () => {
  useEffect(
    () => {
    }, [])
  const classes = useStyles();
  return (
    <div className={classes.mainbtnDiv}>
      <div className={classes.mapGal}>
        <div className={classes.mapGalInner}>
          <MapContext.Consumer>
            {({ data, handleClick }) => <div className={classes.mapBlock}>
              <div className={classes.thumbnailLeft}><p>Navigation</p><img src={require('../../assets/images/basemap-navigation.jpg')} onClick={() => handleClick('streets-navigation-vector')}></img></div>
              <div className={classes.thumbnailRight}><p>Imagery with Labels</p><img src={require('../../assets/images/basemap-imagery.jpg')} onClick={() => handleClick('hybrid')}></img></div>
              <div className={classes.thumbnailLeft}><p>Light Grey</p><img src={require('../../assets/images/basemap-lightgrey.jpg')} onClick={() => handleClick('gray')}></img></div>
              <div className={classes.thumbnailRight}><p>Dark Grey</p><img src={require('../../assets/images/basemap-darkgrey.jpg')} onClick={() => handleClick('dark-gray')}></img></div>
              <div className={classes.thumbnailLeft}><p>Streets</p><img src={require('../../assets/images/basemap-streets.jpg')} onClick={() => handleClick('streets')}></img></div>
              </div>}
          </MapContext.Consumer>
        </div>
      </div>
    </div>
  );
}

export default Basemaps;
//End Basemaps component code ...
